// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';


const fadeIn = keyframes`
    from{
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const Wrapper = styled.footer`
    display: flex;
    justify-content: center;
    background: ${({ theme }) => theme.secondary};
    color: ${({ theme }) => theme.contrast};

    position: absolute;
    bottom: 0;
    width: 100%;
    opacity: 0;

    animation: ${fadeIn};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`;

const Footer = () => {
    return <Wrapper>Hamilton Manufacturing Corp. ©{new Date().getFullYear()}</Wrapper>;
}

export default Footer;